import React, { SVGProps } from 'react';
import { SvgContainer } from '@/components/icon/SvgContainer';

export const StethoscopeIcon = (props: SVGProps<SVGSVGElement>) => (
  <SvgContainer strokeWidth={1.6} {...props}>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M5 3v6a4 4 0 008 0V3M9 13v3a5 5 0 0010 0v-2"
    />
    <circle
      cx="19"
      cy="11"
      r="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgContainer>
);
